import { axiosInstance } from '@configs/axios/axiosInstance';

import { UpdateUserRequest } from './updateUser.types';

/**
 * Update an existing B2C user for a given organization.
 * Endpoint: PUT /users
 *
 * `organizationId` is sent as the X-Organization-ID request header.
 * Returns 204 No Content on success.
 */
export async function updateUser(
  organizationId: string,
  data: UpdateUserRequest
): Promise<void> {
  await axiosInstance.put(`/users/${data.id}`, data, {
    headers: { 'X-Organization-ID': organizationId },
  });
}
